export default {
  picker: {
    titleGeometries: 'ジオメトリを選択',
    titleMeshes: 'メッシュを選択',
    descriptionGeometries:
      'その場でメッシュ化するジオメトリを選びます。各項目が設計点マトリクスに行を追加します。',
    descriptionMeshes:
      '入力として使用する既存のメッシュを選びます。各項目が設計点マトリクスに行を追加します。',
    searchGeometries: 'ジオメトリを検索...',
    searchFiles: 'ファイルを検索...',
    sortGeometries: 'ジオメトリを並べ替え',
    sortRecent: '新しい順',
    sortOldest: '古い順',
    sortAToZ: 'A → Z',
    sortZToA: 'Z → A',
    sortSmallest: '小さい順',
    sortLargest: '大きい順',
    sortTypeAToZ: '種類 A → Z',
    sortTypeZToA: '種類 Z → A',
    ascendingFlip: '昇順 — クリックで切り替え',
    descendingFlip: '降順 — クリックで切り替え',
    sortAscending: '昇順で並べ替え',
    sortDescending: '降順で並べ替え',
    selectedCount: '{{count}} 件選択中',
    cancel: 'キャンセル',
    done: '完了',
    noGeometries:
      'ジオメトリが見つかりません。まず MeshGen でジオメトリをアップロードしてください。',
    noMatches: '「{{query}}」に一致する項目はありません',
  },
  dropzone: {
    dragDropGeometries: 'ジオメトリファイルをドラッグ＆ドロップ、または',
    browseFiles: 'ファイルを参照',
    geometryFormats: 'STEP、STP、OBJ、STL • 各ファイル最大 1 GB',
    uploadFailed: 'アップロードに失敗しました',
    uploadFailedReason: 'アップロードに失敗しました: {{reason}}',
    rejectedOne: '{{name}}: 種類が無効かサイズが大きすぎます。',
    rejectedMany:
      '{{count}} 件のファイルが拒否されました — 種類が無効かサイズが大きすぎます。',
    cancelUpload: 'アップロードをキャンセル',
    dismiss: '閉じる',
  },
  tree: {
    noGeometries:
      'ジオメトリが見つかりません。まず MeshGen でジオメトリをアップロードしてください。',
    filteringBy: 'フィルター条件:',
    clear: 'クリア',
    noMeshesMatch: '{{filters}} に一致するメッシュはありません。',
    meshCount_one: '{{count}} 件のメッシュ',
    meshCount_other: '{{count}} 件のメッシュ',
    elements: '{{value}} 要素',
    removeTagFilter: '「{{label}}」フィルターを削除',
    filterByTag: '「{{label}}」で絞り込む',
  },
  meshChips: {
    cfdInt: 'CFD · 内部',
    cfdExt: 'CFD · 外部',
    cht: 'CHT',
    fea: 'FEA',
    wrap: 'Wrap',
    repair: 'Repair',
    tet: 'Tet',
    hex: 'Hex',
    poly: 'Poly',
    bl: 'BL',
    tagged: 'タグ付き',
    untagged: '未タグ付け',
    sharedFaceJoins: '共有面 {{count}}',
    sharedFaceJoinsHint: '体積間で面のメッシュ節点を共有する結合界面です。',
    nodeOnlyJoins: '節点のみ {{count}}',
    nodeOnlyJoinsHint:
      '辺または点でのみ接触し、熱伝導に使える共有面積はありません。',
    gapContacts: '未結合ペア {{count}}',
    gapContactsHint:
      '近接する未結合面です。接触候補であり、確定した結合ではありません。',
    taggedMissingInternal: '境界割り当てに {{parts}} が不足しています',
    taggedMissingCht: '{{parts}} が不足しています',
    roleInlet: 'インレット',
    roleOutlet: 'アウトレット',
    roleFluidRegion: '流体領域',
    roleSolidRegion: '固体領域',
  },
  geometryPicker: {
    title: 'ジオメトリ',
    searchGeometries: 'ジオメトリを検索...',
    noGeometries:
      'ジオメトリが見つかりません。まず MeshGen でジオメトリをアップロードしてください。',
    noMatches: '「{{query}}」に一致する項目はありません',
    prev: '前へ',
    next: '次へ',
  },
  meshDropzone: {
    uploading: '{{name}} をアップロード中...',
    uploaded: '{{name}} をアップロードしました',
    failed: '{{name}} が失敗しました',
    tryAgain: '再試行',
    uploadFailed: 'アップロードに失敗しました',
    invalidFile: 'ファイルの種類が無効かサイズが大きすぎます。',
    dragDropMesh: 'メッシュファイルをドラッグ＆ドロップ、または',
    browseFromFile: 'ファイルから参照',
    unitWarning:
      'アップロードするメッシュはメートル (SI) 単位である必要があります。Khorium はアップロードを再スケールしません — mm で作成されたメッシュは 1000 倍大きくなります。単位を設定するには MeshGen でメッシュを生成してください。',
  },
  viewer: {
    selectToPreview: 'サイドバーからファイルを選択してプレビュー',
    showingCadHint:
      'CAD テッセレーションを表示中 — セル表示は Mesh に切り替えてください',
    showingMeshHint:
      'メッシュを表示中 — 節点熱荷重と節点ピックにはメッシュ節点が必要です',
    viewLabel: '表示',
    autoCad: '自動 (CAD)',
    autoMesh: '自動 (Mesh)',
    cadTessellation: 'CAD テッセレーション',
    meshCells: 'メッシュセル',
    previewUnsupported: 'このファイル形式はプレビューに対応していません',
    previewPreparing: 'ジオメトリプレビューを準備中…',
    previewUnavailable: 'ジオメトリプレビューを利用できません',
  },
  studyTree: {
    files: 'ファイル',
    change: '変更',
    selectFiles: 'ファイルを選択',
    openInMeshgen: 'MeshGen で開く',
    removeFromSelection: '選択から削除',
    removeItem: '{{filename}} を選択から削除',
    meshStatus: 'メッシュステータス: {{status}}',
    qualityFailed: '失敗',
    qualityCancelled: 'キャンセル済み',
    qualityMeshing: 'メッシュ化中...',
    qualityNa: '品質は該当なし',
    qualityReady: '品質準備完了',
    qualitySicn: 'SICN {{value}}',
    qualityGamma: 'Gamma {{value}}',
    qualitySkew: 'Skew {{value}}',
  },
} as const;
